// @givmo/board — the line and the actions that open each part of the Governance page.
//
// Each part keeps the one sentence its former page led with and the actions that belonged to it: a
// part's actions act on that part only, so they sit with it rather than in the page header. Stacked
// below `sm`, the PageHeader's own rule, so a phone never squeezes the sentence beside two buttons.

import type { ReactNode } from 'react';

export interface GovernancePartHeaderProps {
  /** One honest sentence about what this part is (it may end with a "How this works" link). */
  description: ReactNode;
  /** The part's own actions. */
  actions?: ReactNode;
}

export function GovernancePartHeader({ description, actions }: GovernancePartHeaderProps) {
  return (
    <div className="flex flex-col gap-12 sm:flex-row sm:items-start sm:justify-between sm:gap-16">
      <p className="min-w-0 font-sans text-s14 font-w400 leading-h15 tracking-givmo text-text-secondary">
        {description}
      </p>
      {actions !== undefined ? (
        <div className="flex shrink-0 flex-wrap gap-10">{actions}</div>
      ) : null}
    </div>
  );
}
